import { render, staticRenderFns } from "./metroBox.vue?vue&type=template&id=061fe033&scoped=true"
import script from "./metroBox.vue?vue&type=script&lang=js"
export * from "./metroBox.vue?vue&type=script&lang=js"
import style0 from "./metroBox.vue?vue&type=style&index=0&id=061fe033&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "061fe033",
  null
  
)

export default component.exports